import { c as _c } from "react/compiler-runtime";
import { IcoForbid40 } from '@onefootprint/icons';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Subsection from '../../../../../subsection';
import type { FormattedAddress } from '../../../../onboarding-business-insight.types';
import AddressCard from './components/address-card';
import MapComponent from './components/map';
import MapMarker from './components/map/components/map-marker';
import SatelliteImage from './components/map/components/satellite-image';
import useAddressCoordinates from './utils/use-address-coordinates';
export type OfficesProps = {
  data: FormattedAddress[];
};
const Content = t0 => {
  const $ = _c(53);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.offices"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    data: dataWithCoordinates
  } = useAddressCoordinates(data);
  const [selectedAddress, setSelectedAddress] = useState(dataWithCoordinates[0]);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const addressRefs = useRef(t2);
  let t3;
  if ($[2] !== dataWithCoordinates[0] || $[3] !== selectedAddress) {
    t3 = () => {
      if (!selectedAddress && dataWithCoordinates[0]) {
        setSelectedAddress(dataWithCoordinates[0]);
      }
    };
    $[2] = dataWithCoordinates[0];
    $[3] = selectedAddress;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== dataWithCoordinates || $[6] !== selectedAddress) {
    t4 = [dataWithCoordinates, selectedAddress];
    $[5] = dataWithCoordinates;
    $[6] = selectedAddress;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = address => {
      setSelectedAddress(address);
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleSelectFromMap = t5;
  let t6;
  let t7;
  if ($[9] !== selectedAddress) {
    t6 = () => {
      if (selectedAddress) {
        const cardRef = addressRefs.current[selectedAddress.id];
        if (cardRef?.parentElement) {
          cardRef.parentElement.scrollTo({
            top: cardRef.offsetTop - 16,
            behavior: "smooth"
          });
        }
      }
    };
    t7 = [selectedAddress];
    $[9] = selectedAddress;
    $[10] = t6;
    $[11] = t7;
  } else {
    t6 = $[10];
    t7 = $[11];
  }
  useEffect(t6, t7);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t8;
  let t9;
  if ($[12] !== dataWithCoordinates || $[13] !== selectedAddress || $[14] !== t) {
    const renderCards = () => {
      if (dataWithCoordinates.length === 0) {
        return <div key="empty" className="flex flex-col gap-5 justify-center items-center w-full h-full flex-grow-1"><IcoForbid40 /><p className="text-label-2">{t(_temp)}</p></div>;
      }
      return dataWithCoordinates.map(address_0 => {
        const isSelected = selectedAddress?.id === address_0.id;
        return <AddressCard key={address_0.id} address={address_0} isSelected={isSelected} onSelect={setSelectedAddress} ref={el => {
          addressRefs.current[address_0.id] = el;
        }} />;
      });
    };
    let t14;
    if ($[22] !== dataWithCoordinates || $[23] !== selectedAddress?.id) {
      t14 = () => dataWithCoordinates.filter(_temp2).map(address_2 => {
        const isSelected_0 = selectedAddress?.id === address_2.id;
        return <MapMarker key={address_2.id} id={address_2.id} onClick={() => handleSelectFromMap(address_2)} latitude={address_2.latitude as number} longitude={address_2.longitude as number} isSelected={isSelected_0} />;
      });
      $[22] = dataWithCoordinates;
      $[23] = selectedAddress?.id;
      $[24] = t14;
    } else {
      t14 = $[24];
    }
    const renderMarkers = t14;
    T0 = Subsection;
    t13 = false;
    t11 = "relative flex flex-col w-full md:block md:h-[400px]";
    let t15;
    if ($[25] !== renderMarkers) {
      t15 = renderMarkers();
      $[25] = renderMarkers;
      $[26] = t15;
    } else {
      t15 = $[26];
    }
    let t16;
    if ($[27] !== dataWithCoordinates) {
      t16 = id => handleSelectFromMap(dataWithCoordinates.find(address_3 => address_3.id === id) as FormattedAddress);
      $[27] = dataWithCoordinates;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    let t17;
    if ($[29] !== selectedAddress || $[30] !== t15 || $[31] !== t16) {
      t17 = <MapComponent markers={t15} selectedAddress={selectedAddress} onSelect={t16} />;
      $[29] = selectedAddress;
      $[30] = t15;
      $[31] = t16;
      $[32] = t17;
    } else {
      t17 = $[32];
    }
    const t18 = selectedAddress?.latitude;
    const t19 = selectedAddress?.longitude;
    let t20;
    if ($[33] !== t18 || $[34] !== t19) {
      t20 = <SatelliteImage latitude={t18} longitude={t19} />;
      $[33] = t18;
      $[34] = t19;
      $[35] = t20;
    } else {
      t20 = $[35];
    }
    if ($[36] !== t17 || $[37] !== t20) {
      t12 = <div className="relative h-48 shrink-0 md:absolute md:inset-0 md:h-auto">{t17}{t20}</div>;
      $[36] = t17;
      $[37] = t20;
      $[38] = t12;
    } else {
      t12 = $[38];
    }
    t10 = "relative z-10 flex-1 min-h-0 bg-gradient-to-r from-background/95 to-background/80 md:flex-none md:h-full md:max-w-[280px]";
    t8 = "overflow-y-auto p-3 space-y-2 h-full scrollbar-hide";
    t9 = renderCards();
    $[12] = dataWithCoordinates;
    $[13] = selectedAddress;
    $[14] = t;
    $[15] = T0;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[15];
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t13 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t14;
  if ($[39] !== t8 || $[40] !== t9) {
    t14 = <div className={t8}>{t9}</div>;
    $[39] = t8;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t10 || $[43] !== t14) {
    t15 = <div className={t10}>{t14}</div>;
    $[42] = t10;
    $[43] = t14;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== t11 || $[46] !== t12 || $[47] !== t15) {
    t16 = <div className={t11}>{t12}{t15}</div>;
    $[45] = t11;
    $[46] = t12;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== T0 || $[50] !== t13 || $[51] !== t16) {
    t17 = <T0 padding={t13}>{t16}</T0>;
    $[49] = T0;
    $[50] = t13;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  return t17;
};
export default Content;
function _temp($) {
  return $.empty;
}
function _temp2(address_1) {
  return address_1.latitude && address_1.longitude;
}